import { FC } from 'react';

import { PriceBlockSlot, PriceBlockWrapper } from './CartSummaryTotalPriceBlock.styles';

type Props = {
    title: string;
    price: string;
    priceDataTest?: string;
    isLarge?: boolean;
    isStickySummary?: boolean;
    ariaLabel?: string;
};

export const PriceBlock: FC<Props> = ({ title, price, priceDataTest, isLarge, isStickySummary, ariaLabel }) => {
    return (
        <PriceBlockWrapper $isLarge={isLarge} $isStickySummary={isStickySummary}>
            <PriceBlockSlot as="dt">{title}</PriceBlockSlot>
            <dd>
                <PriceBlockSlot dataTest={priceDataTest} trigger={price} ariaLabel={ariaLabel}>
                    <span aria-hidden={!!ariaLabel}>{price}</span>
                </PriceBlockSlot>
            </dd>
        </PriceBlockWrapper>
    );
};
